<template>
    <section class="error404">
        <div class="m-two-column fixed image-right content-two-third">
            <div class="o-container">
                <div class="o-row">
                    <div class="content-col o-col-sm-12 o-col-md-8">
                        <h4 class="subtitle">Page not found (404)</h4>
                        <h2>We're sorry but the page you're looking for doesn't appear to exist or has been moved.</h2>
                        <form id="searchform" method="get" action="<?=get_home_url();?>">
                            <input type="text" placeholder="Search"  name="s" id="s" required>
                            <button class="c-button c-button--tertiary" type="submit">Search</button>
                        </form>				
                    </div>
                </div>
            </div>
            <div class="image-col" style="background-image:url(/app/uploads/2018/11/404.jpg)"></div>
        </div>
    </section>
</template>

<script>
export default {
    mounted() {
        
    },
}
</script>
